///include /assets/js/app/p/checkout-info.js
///include /assets/js/app/p/payment-info-capture.js
class CardCapture extends PaymentInfoCaptureDriver {
    static get infoType() {
        return "card"
    }
    static get type() {
        return "card"
    }
    /**
     * @return {Promise<CardCaptureDriver|null|undefined>}
     */
    static async getDriver() {
        if(this.driver === undefined) {
            const info = await CheckoutInfo.inst.preloadSingle("info")
            if(this.driver) return this.driver
            if(info.card) {
                const c = CardCaptureDriver.byName[info.card.type]
                if(c) {
                    /** @type {CardCaptureDriver|null} */
                    this.driver = new c()
                } else {
                    console.error(`No driver for ${info.card.type}`)
                    this.driver = null
                }
            } else {
                this.driver = null
            }
        }
        return this.driver
    }
    /**
     *
     * @param {?string} return_url
     * @param {?string} failureReason
     * @param {boolean} from_vue
     */
    static async init(return_url = null, failureReason = null, from_vue = true) {
        if(failureReason == "declined") {
            const dm = document.querySelector("#declined-message")
            if(dm instanceof HTMLElement) {
                dm.style.display = ""
            } else {
                console.error(
                    "Declined but notification element is missing"
                )
            }
        }
        const driver = await this.getDriver()
        if(driver) {
            driver.init(return_url, from_vue)
        }
    }
    /**
     * @param {HTMLFormElement} pf
     */
    static async initForm(pf) {
        const driver = await this.getDriver()
        if(driver) {
            await driver.initForm(pf)
        }
    }
}

class CardCaptureDriver extends PaymentInfoCapturePGDriver {
    static get byName() {
        if(!this._byName) {
            /** @type {{[name: string]: typeof CardCaptureDriver}} */
            this._byName = {}
        }
        return this._byName
    }
    /**
     * @type {string}
     */
    static get type() {
        throw new Error("Not implemented")
    }
    /**
     * @param {typeof CardCaptureDriver} d
     */
    static add(d) {
        this.byName[d.type] = d
    }
    get canCapture() {
        return true
    }
    /**
     *
     * @param {?string} return_url
     * @param {boolean} [from_vue]
     */
    init(return_url = null, from_vue = true) {
        throw new Error("Not implemented")
    }
    /**
     * @param {HTMLFormElement} pf
     */
    async initForm(pf) {
        throw new Error("Not implemented")
    }
    async submitForm() {
        throw new Error(
            `Cannot submit form for non-supported capture provider`
        )
    }
}

PaymentInfoCapture.register("card", CardCapture)